import React, { useState } from 'react'

import {ACCOUNT_TYPE} from "../../../utils/constants";
import Tab from "../../common/Tab";
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { setSignupData } from '../../../slices/authSlice';
import { sendOtp } from '../../../services/operations/authAPI';
import { useNavigate } from 'react-router-dom';

const SignupForm = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [accountType, setAccountType] = useState(ACCOUNT_TYPE.STUDENT);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const {firstName, lastName, email, password, confirmPassword} = formData;
  const tabData = [
    {
      id: 1,
      tabName: "Student",
      type: ACCOUNT_TYPE.STUDENT,
    },
    {
      id: 2,
      tabName:"Instructor",
      type: ACCOUNT_TYPE.INSTRUCTOR,
    }
  ]

  const handleOnChange = (e)=>{
    setFormData((prevData) =>({
      ...prevData,
      [e.target.name]: e.target.value,
    }))
  }

  const handleOnSubmit = (e) =>{
    e.preventDefault();

    if(password !== confirmPassword){
      toast.error("Passwords do not match");
      return;
    }

    const signupData = {
      ...formData,
      accountType
    }
    dispatch(setSignupData(signupData));
    dispatch(sendOtp(formData.email, navigate));
    setFormData({ firstName: "", lastName: "", email: "", password: "", confirmPassword: ""});
    setAccountType(ACCOUNT_TYPE.STUDENT);
  }

  return (
    <div>
        <Tab tabData={tabData} field={accountType} setField={setAccountType}/>
        <form className='flex flex-col w-full gap-y-4' onSubmit={handleOnSubmit}>
        <div className="flex gap-x-4">
          <label >
            <p className="mb-1 text-[0.875rem] leading-[1.375rem] text-richblack-5">First Name <sup className="text-pink-200">*</sup></p>
            <input required type="text" name="firstName" value={firstName} placeholder='enter first name' className='form-style w-full' onChange={handleOnChange}/>
          </label>
          <label >
            <p className="mb-1 text-[0.875rem] leading-[1.375rem] text-richblack-5">Last Name <sup className="text-pink-200">*</sup></p>
            <input required type="text" name="lastName" value={lastName} placeholder='enter last name' className='form-style w-full' onChange={handleOnChange}/>
          </label>
        </div>
        <label className='w-full'>
            <p className="mb-1 text-[0.875rem] leading-[1.375rem] text-richblack-5">Email Address <sup className="text-pink-200">*</sup></p>
            <input required type="email" name="email" value={email} placeholder='enter address' className='form-style w-full' onChange={handleOnChange}/>
        </label>
        <div className="flex gap-x-4">
          <label className='relative'>
            <p className="mb-1 text-[0.875rem] leading-[1.375rem] text-richblack-5">Create Password <sup className="text-pink-200">*</sup></p>
            <input required type={showPassword ? "text" : "password"} name='password' value={password} placeholder='enter password' className="form-style w-full !pr-10" onChange={handleOnChange}/>
            <span className="absolute right-3 top-[38px] z-[10] cursor-pointer" onClick={()=> setShowPassword((prev) => !prev)}>
              {showPassword ? (
                <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
              ): (
                <AiOutlineEye fontSize={24} fill="#AFB2BF" />
              )
              }
            </span>
          </label>
          <label className='relative'>
            <p className="mb-1 text-[0.875rem] leading-[1.375rem] text-richblack-5">Confirm Password <sup className="text-pink-200">*</sup></p>
            <input required type={showConfirmPassword ? "text" : "password"} name='confirmPassword' value={confirmPassword} placeholder='confirm password' className="form-style w-full !pr-10" onChange={handleOnChange}/>
            <span className="absolute right-3 top-[38px] z-[10] cursor-pointer" onClick={()=> setShowConfirmPassword((prev) => !prev)}>
              {showConfirmPassword ? (
                <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
              ): (
                <AiOutlineEye fontSize={24} fill="#AFB2BF" />
              )
              }
            </span>
          </label>
        </div>
        <button type="submit" className="mt-6 rounded-[8px] bg-yellow-50 py-[8px] px-[12px] font-medium text-richblack-900">Create Account</button>
      </form>
    </div>
  )
}

export default SignupForm
